// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1X2xY","author":"Table_author__3XQGt","authorImage":"Table_authorImage__2WApc","unreadRow":"Table_unreadRow__3ECe-"};